import React, { useEffect, useState, useRef, useMemo } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react';
import CardIcon from 'components/Card/CardIcon';
import {
  Assignment,
  AssignmentTurnedIn,
  AssignmentTurnedInOutlined,
  Backup,
  Search,
  Sync,
} from '@material-ui/icons';
import Button from 'components/CustomButtons/Button';
import { Toasty, useToasty } from 'hooks/Toasty';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js';

import { wsFindBy, wsGetAll, wsCreate, wsUpdate, wsGet } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import moment from 'moment';

import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';

import { AllowedGuard } from 'components/Tvendo/Common/UserAction';

import { ConstantPermissions } from 'contexts/useConstant';
import { useAuth } from 'hooks/useAuth';
import { wsUpdateMasive } from 'services/WService';
import SweetAlert from 'react-bootstrap-sweetalert';
import stylesSweealert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import Adornment from 'components/Tvendo/Common/Adornment';
import InvoiceSubDetail from './InvoiceSubDetail';
import ProviderModal from './ProviderModal';
import ModalPricesUpdate from '../../Details/Modal/ModalPricesUpdate';
import { useModal } from 'hooks/useModal';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { DataGrid, esES } from '@mui/x-data-grid';
import { wsPost } from 'services/WService';

const useStyles = makeStyles({
  ...styles,
  ...stylesSweealert,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  marginRight: {
    float: 'right',
  },
});

/**
 *
 * @param {valor} numero
 * @returns true or false
 */
function isDecimal(numero) {
  let dataReturn = false;
  if (isNaN(numero)) {
    dataReturn = false;
  } else {
    if (numero % 1 == 0) {
      dataReturn = false;
    } else {
      dataReturn = true;
    }
  }
  return dataReturn;
}

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const columns = [
  {
    field: 'num',
    width: 10,
    align: 'right',
    headerName: '#',
    disableColumnMenu: 100,
    hideable: false,
    sortable: false,
    valueGetter: (params) => params.api.getRowIndex(params.id) + 1,
  },
  {
    field: 'CardCode',
    width: 120,
    headerName: 'Código',
    hideable: false,
    sortable: false,
  },
  {
    field: 'CardName',
    width: 270,
    headerName: 'Nombre',
    hideable: false,
    sortable: false,
  },
  {
    field: 'address',
    width: 230,
    headerName: 'Dirección',
    hideable: false,
    sortable: false,
  },
  {
    field: 'CardType', 
    width: 100,
    headerName: 'Tipo',
    hideable: false,
    sortable: false,
  },
  {
    field: 'purchase_type_description',
    width: 130,
    headerName: 'Tipo compra',
    hideable: false,
    sortable: false,
  },
  {
    field: 'DocDate',
    width: 120,
    headerName: 'Fec. Doc',
    hideable: false,
    sortable: false,
  },
  {
    field: 'DocDueDate',
    width: 120,
    headerName: 'Fec. Venc.',
    hideable: false,
    sortable: false,
  },
  { 
    field: 'tax_date', 
    width: 120, 
    headerName: 'Fec. Cont.', 
    hideable: false, 
    sortable: false 
  },
  {
    field: 'base_zone_description',
    width: 85,
    headerName: 'Zona',
    hideable: false,
    sortable: false,
  },
  {
    field: 'ReceiptType',
    width: 90,
    headerName: 'Tipo Doc.',
    hideable: false,
    sortable: false,
  },
  {
    field: 'ReceiptSerie',
    width: 110,
    headerName: 'Serie Doc.',
    hideable: false,
    sortable: false,
  },
  {
    field: 'ReceiptNumber',
    width: 140,
    headerName: 'Numero Doc.',
    hideable: false,
    sortable: false,
  },
  {
    field: 'PymntGroup',
    width: 130,
    headerName: 'Termino de pago',
    hideable: false,
    sortable: false,
  },
  {
    field: 'DocTotal',
    width: 110,
    headerName: 'Total Doc.',
    hideable: false,
    sortable: false,
    type: 'number',
  },
  {
    field: 'op_gravada',
    width: 130,
    headerName: 'Op. Agravada',
    hideable: false,
    sortable: false,
    type: 'number',
  },
  {
    field: 'sum_igv',
    width: 140,
    headerName: 'Tot. Impuestos',
    hideable: false,
    sortable: false,
    type: 'number',
  },
  {
    field: 'Dscription',
    width: 200,
    headerName: 'Descripción',
    hideable: false,
    sortable: false,
  },
  {
    field: 'pymt_concept_description',
    width: 200,
    headerName: 'Concepto',
    hideable: false,
    sortable: false,
  },
];

export default WithApp(function InsertInvoice(props) {
  const classes = useStyles();

  //documentos
  const inputXml = useRef(null);
  const inputPdf = useRef(null);
  const [namePdf, setNamePdf] = useState('');
  const [nameXml, setNameXml] = useState('');

  const queryType = useQuery().get('type'); //tipo de factura
  const { id } = useParams();
  const form = useRef(null);
  const [notify, showNotify] = useToasty();
  const [isId, setIsId] = useState(false);
  const [existPurchaseDetails, setExistPurchaseDetails] = useState(false);
  const [alert, setAlert] = useState(null);
  const [minDate, setMinDate] = useState(null);
  const [checkGuide, setCheckGuide] = useState(false);

  const { hasPermission } = useAuth();
  const [soloMercaderia, setSoloMercaderia] = useState(false);

  const [open, setOpen] = useState(false); // modal para elegir proveedor
  const [modelPrices, setOpenPrices] = useModal();

  const [dataInital, setDatainital] = useState({});

  const [limitDiffProrate, setLimitDiffProrate] = useState(0.02);
  const [warehouses, setWarehouses] = useState([]);
  const [sunatDocumentTypes, setSunatDocumentTypes] = useState([]);
  const [currencys, setCurrencys] = useState([]);
  const [paymentTs, setPaymentTs] = useState([]);
  const [purchaseTypes, setPurchaseTypes] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [zones, setZones] = useState([]);
  const [purchOrder, setPurchOrder] = useState([]);
  const [pOrderDetalle, setPOrderDetalle] = useState([]);
  const [checkPurchOrder, setCheckPurchOrder] = useState(true);

  const [purchaseDetails, setPurchaseDetails] = useState([]);

  const [purchase, setPurchase] = useState({});
  const [unitValue, setUnitValue] = useState('N');
  const [stateValidation, setStateValidation] = useState(false);
  const disabledComponent = purchase.proc_status !== 'V';
  const [purchRetention, setPurchRetention] = useState();
  const [purchRetentionDocument, setPurchRetentionDocument] = useState([]);

  const inputFileRefOpe = useRef(null);
  const [importDataOperation, setImportDataOperation] = useState(undefined);
  const [selectionModel, setSelectionModel] = useState([]);
  const [processing, setProcesing] = useState(false);

  // #region -- listados --
  async function getPurchase() {
    let response = await wsGet('purch/purchase', id);
    if (response.success) {
      for (let obj in response.data) {
        if (isDecimal(response.data[obj])) {
          response.data[obj] = parseFloat(response.data[obj]).toFixed(2);
        }
      }
      setDatainital(response.data);
      setPurchase(response.data);
      setStateValidation(response.data.proc_status == 'D' ? false : true);
    }
  }

  async function getConfiguration() {
    let response = await wsGet('base/configuration', 'purchase_prorate');
    if (response.success) setLimitDiffProrate(response.data);
  }

  async function ListWarehouse() {
    let response = await wsFindBy('logi/warehouse', { warehouse_type: 'N' });
    if (response.success) setWarehouses(response.data);
  }

  async function listSunatDocumentType() {
    let response = await wsGetAll('base/sunat-document-type');
    if (response.success) setSunatDocumentTypes(response.data);
  }

  async function listCurrency() {
    let response = await wsGetAll('base/currency');
    if (response.success) setCurrencys(response.data);
  }

  async function listPaymentTs() {
    let response = await wsGetAll('base/payment-term');
    if (response.success) setPaymentTs(response.data);
  }

  async function listPurchaseTypes() {
    let response = await wsGet('purch/purchase-type');
    if (response.success) setPurchaseTypes(response.data);
  }

  async function listTaxes() {
    let response = await wsGetAll('base/tax');
    if (response.success) setTaxes(response.data);
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listPurchOrders() {
    let state = ['S','R'];
    let response = await wsFindBy('purch/purchase-order', {state, base_business_partner_id: purchase.base_business_partner_id, logi_warehouse_id: purchase.logi_warehouse_id});
    if (response.success) setPurchOrder(response.data);
  }

  async function listPOrderDetails() {
    let response = await wsFindBy('purch/purchase-order-detalle', {purch_order_id: purchase.purch_order_id});
    if (response.success) setPOrderDetalle(response.data);
  }

  // #endregion -- fin de listados

  async function refreshPurchase() {
    let response = await wsCreate(`purch/purchase/${id}/sync-header`);
    if (response.success) {
      setPurchase({}); //uso esta linea para refrescar la informacion de la cabecera

      for (let obj in response.data) {
        if (isDecimal(response.data[obj])) {
          response.data[obj] = parseFloat(response.data[obj]).toFixed(2);
        }
      }
      setPurchase(response.data);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  const getValuesInput = (ref) => {
    let dataForm = {};
    for (let input of ref.current.querySelectorAll('[name]')) {
      dataForm[input.name] = input.value;
    }
    return dataForm;
  };

  /**
   * @param {*} data
   * @param {Boolean} reloadDetails
   * @returns {void}
   */
  async function saveHeader(data) {
    let dataForm = getValuesInput(form);
    Object.assign(dataForm, {
      base_business_partner_id: data.base_business_partner_id,
    });
    if (id != 0) {
      let newData = {};
      for (let key in dataForm) {
        if (dataInital[key] != dataForm[key]) {
          newData[key] = dataForm[key];
        }
      }
      if (Object.keys(newData).length < 1) {
        return;
      }
      /* console.log('editando', newData); */

      let response = await wsUpdate('purch/purchase', id, newData);
      if (response.success) {
        showNotify(response.message);
        getPurchase();
        listPurchaseDetails(id);
      } else {
        showNotify(response.message, 'error');
      }
    } else {
      /* console.log('Creando', { ...dataForm, origin: queryType }); */
      let response = await wsCreate('purch/purchase-manual', { ...dataForm, origin: queryType });
      if (response.success) {
        window.location.href = `/admin/compras/operaciones/${
          queryType === 'M' ? 'factura' : 'factura-proveedores'
        }/${response.data.id}?type=${queryType}`;
        setIsId(true);
        showNotify(response.message);
      } else {
        showNotify(response.message, 'error');
      }
    }
  }
  async function savePurchOrder() {
    const dataOrder = form.current.querySelector('[name="purch_order_id"]')?.value;
    /* console.log('editando', newData); */

    let response = await wsUpdate(`purch/purchase/${id}/update-purch-order`, {purch_order_id: dataOrder});
    if (response.success) {
      showNotify(response.message);
      getPurchase();
      listPurchaseDetails(id);
    } else {
      showNotify(response.message, 'error');
    }

  }

  /**
   * Funciones complementarias internas
   */
  //#region
  //calcula los totales de los detalles
  function calcTotals(dataArray) {
    let dataObj = { gtotal: 0, VatSum: 0, DiscSum: 0, op_gravada: 0, op_exonerada: 0 };
    for (let obj of dataArray) {
      dataObj.gtotal += obj.gtotal;
      dataObj.VatSum += obj.VatSum;
      dataObj.DiscSum += obj.DiscSum;
    }
    return dataObj;
  }

  //#endregion

  async function listPurchaseDetails(id, validate, dataProcStatus) {
    let response = await wsFindBy('purch/purchase-detail', 'purch_purchase_id', id);
    if (response.success) {
      let data = response.data.map((item) => {
        if ('UseBaseUn' in item && item.UseBaseUn === 'N') {
          item.UseBaseUn = 'No';
        }
        if ('UseBaseUn' in item && item.UseBaseUn === 'Y') {
          item.UseBaseUn = 'Si';
        }
        if ('PriceTypeCode' in item && item.PriceTypeCode === '01') {
          item.PriceTypeCode = 'P/U(Incluye IGV)';
        }
        if ('PriceTypeCode' in item && item.PriceTypeCode === '02') {
          item.PriceTypeCode = 'Valor ref. uni. en oper. no onerosas';
        }
        return item;
      });
      setPurchaseDetails(data);
      setExistPurchaseDetails(response.data.length > 0 ? true : false);
      if (validate) {
        let dataValidation = calcTotals(response.data);
        updateState(
          { ...dataProcStatus, u_syp_mntdet: purchRetention?.[0]?.u_syp_mntdet },
          dataValidation
        );
      }
    }
  }

  async function updateState(data, paramsValid) {
    if (
      parseFloat(paramsValid.gtotal).toFixed(2) == parseFloat(purchase.DocTotal).toFixed(2) &&
      parseFloat(paramsValid.VatSum).toFixed(2) == parseFloat(purchase.VatSum).toFixed(2) &&
      parseFloat(paramsValid.DiscSum).toFixed(2) == parseFloat(purchase.DiscSum).toFixed(2)
    ) {
      let response = await wsUpdateMasive('purch/purchase/' + id + '/change-state', data);
      if (response.success) {
        getPurchase();
        showNotify(response.message);
      } else {
        if (
          response.data?.prices !== undefined &&
          response.data?.products !== undefined &&
          response.data?.price_lists !== undefined
        ) {
          setOpenPrices({
            open: true,
            prices: response.data.prices,
            products: response.data.products,
            priceLists: response.data.price_lists,
          });
        } else {
          showNotify(response.message, 'error');
        }
      }
    } else {
      showNotify('El detalle no coincide con los totales', 'info');
    }
  }

  const hideAlert = () => {
    setAlert(null);
  };
  function alertProrate() {
    let dataValidation = calcTotals(purchaseDetails);
    setAlert(
      <SweetAlert
        input
        required
        defaultValue={dataValidation.gtotal || 0}
        validationMsg="Ingrese un valor"
        inputType="number"
        style={{ display: 'block', marginTop: '-100px' }}
        title="Ingresar monto total"
        onConfirm={(e) => {
          let limitMaxProrate = parseFloat(parseFloat(dataValidation.gtotal) + limitDiffProrate);
          let limitMinProrate = parseFloat(parseFloat(dataValidation.gtotal) - limitDiffProrate);
          if (e > limitMaxProrate || e < limitMinProrate) {
            showNotify(`La diferencia no puede ser mayor a ${limitDiffProrate}`, 'info');
          } else {
            prorate({ prorate: e });
            hideAlert();
          }
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Este monto reemplaza al total de la factura y detalles
      </SweetAlert>,
    );
  }

  async function prorate(data) {
    let response = await wsCreate(`purch/purchase/${id}/prorate`, data);
    if (response.success) {
      getPurchase();
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function uploadFile(type, file) {
    let fd = new FormData();
    console.log(type, file);
    fd.append(type, file);

    let response = await wsCreate(`purch/purchase/${id}/${type}`, fd);
    if (response.success) {
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listSunatDocumentType();
    listCurrency();
    listPaymentTs();
    if (id != 0) {
      getPurchase();
      getConfiguration();
      listPurchaseDetails(id);
      setIsId(true);
    }
    if (queryType == 'P') {
      listPurchaseTypes();
      listTaxes();
      listZones();
    } else if (queryType == 'M') {
      ListWarehouse();
    }
  }, []);

  useEffect(() => {
    if(purchase.id && purchase.proc_status !== 'D'){
      listPurchOrders();
      return () => {
        setPurchOrder([]);
      };
    }
  }, [purchase]);

  useEffect(() => {
    if(purchase.purch_order_id && purchase.proc_status == 'V'){
      listPOrderDetails();
    }
  }, [purchase]);

  let ruta = () => saveHeader(purchase);;
  if (purchase.proc_status === 'V') {
    ruta = () => savePurchOrder(purchase);
  }

  async function importExcelOperation(e) {
    if (e.target.files.length === 0) {
      window.alert('Seleccione un archivo excel de operaciones');
      e.target.value = '';
      return;
    }
    setProcesing(true);
    let formData = new FormData();
    formData.append('import', e.target.files[0]);

    let res = await wsCreate('purch/purchase/store-excel', formData);
    if (res.success) {
      showNotify(res.message, 'success');
      setImportDataOperation(res.data.map((item, index) => ({ id: index + 1, ...item })));
    } else {
      inputFileRefOpe.current.value = '';
      showNotify(res.message, 'error');
    }
    setProcesing(false);
  }
  
  async function saveFacturas() {
    if (selectionModel.length === 0) {
      showNotify('Seleccione al menos un registro para procesar', 'warning');
      return;
    }
    setProcesing(true);
    const selectedRows = importDataOperation.filter(row =>
      selectionModel.includes(row.id)
    );

    const payload = {
      data: selectedRows.map(row => {
        const priceAfVat = parseFloat(row.op_gravada) + parseFloat(row.sum_igv);
        const gtotal = parseFloat(priceAfVat.toFixed(2));
        const taxCode = parseFloat(row.sum_igv) > 0 ? "IGV" : "EXO_IGV";
        return {
          base_business_partner_id: row.base_business_partner_id,
          purchase_type: row.purchase_type,
          tax_date: row.tax_date,
          reception_date: moment().format('YYYY-MM-DD'),
          DocDueDate: row.DocDueDate,
          DocDate: row.DocDate,
          base_zone_id: row.base_zone_id,
          Address: row.address,
          base_sunat_document_type_id: row.base_sunat_document_type_id,
          ReceiptSerie: row.ReceiptSerie,
          ReceiptNumber: row.ReceiptNumber,
          base_payment_term_id: row.base_payment_term_id,
          DocTotal: row.DocTotal,
          op_gravada: row.op_gravada ?? 0,
          op_exonerada: row.op_exonerada ?? 0,
          op_inafecta: row.op_inafecta ?? 0,
          sum_free_transfer: row.sum_free_transfer ?? 0,
          sum_igv: row.sum_igv ?? 0,
          VatSum: row.VatSum ?? 0,
          total_discount: row.total_discount ?? 0,
          DiscSum: row.DiscSum ?? 0,
          DiscPrcnt: row.DiscPrcnt ?? 0,
          cancelled: 'N',
          Currency: row.Currency ?? 'PEN',
          SumIsc: row.SumIsc ?? 0,
          SumOtTrib: row.SumOtTrib ?? 0,
          SumOtCarg: row.SumOtCarg ?? 0,
          VatSumTotal: row.VatSumTotal ?? 0,
          sum_bonification: row.sum_bonification ?? 0,
          ExtraDays: row.ExtraDays ?? 0,
          doc_status: 'O',
          observation: '',
          is_guide: 'N',
          origin: 'P',
          detail: [{
            tax_code: taxCode,
            Dscription: row.Dscription,
            quantity: 1,
            PriceBefDi: taxCode === 'IGV' ? row.op_gravada : row.DocTotal,
            DiscPrcnt: 0,
            price: taxCode === 'IGV' ? row.op_gravada : row.DocTotal,
            PriceAfVAT: taxCode === 'IGV' ? priceAfVat : row.DocTotal,
            VatSum: row.sum_igv,
            DiscSum: 0,
            LineTotal: taxCode === 'IGV' ? row.op_gravada : row.DocTotal,
            gtotal: taxCode === 'IGV' ? gtotal : row.DocTotal,
            PriceTypeCode: "01",
            pymt_account_concept_id: row.pymt_account_concept_id
          }]
        };
      })
    };

    try {
      const res = await wsPost('purch/purchase-masive-store', payload);
      if (res.success) {
        showNotify(res.message, 'success');
        setImportDataOperation(prev =>
          prev.filter(row => !selectionModel.includes(row.id))
        );

        setSelectionModel([]);
      } else {
        showNotify(res.message, 'error');
      }
    } catch (err) {
      console.error(err);
      showNotify('Error al procesar las facturas', 'error');
    } finally {
      setProcesing(false);
    }
  }

  function emptyImport() {
    setImportDataOperation(undefined);
    setSelectionModel([]);
    if (inputFileRefOpe.current) {
      inputFileRefOpe.current.value = '';
    }
  }

  return (
    <>
      {alert}
      <Toasty action={notify} />
      <ProviderModal
        open={open}
        setOpen={setOpen}
        queryType={queryType}
        soloMercaderia={soloMercaderia}
        purchase={purchase}
        setPurchase={setPurchase}
        id={id}
        existPurchaseDetails={existPurchaseDetails}
        saveHeader={saveHeader}
        setUnitValue={setUnitValue}
      />
      <ModalPricesUpdate
        model={modelPrices}
        setOpen={setOpenPrices}
        showNotify={showNotify}
        purchaseId={purchase.id}
        reload={() => getPurchase()}
        setAlert={setAlert}
        classes={classes}
        purchase={purchase}
      />
      <input
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style={{ display: 'none' }}
        onChange={importExcelOperation}
        ref={inputFileRefOpe}
      />
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color={props.themeContext.buttonColor}>
                <Assignment />
              </CardIcon>
              <span className={classes.cardIconTitle}>
                <h4>Información general</h4>
              </span>
              {queryType == 'P' && hasPermission(ConstantPermissions.PURCH_PURCHASES_MERCHANDISE_INDEX) ? (
                <FormControlLabel
                label="Solo proveedores de mercadería"
                control={
                  <Checkbox
                    checked={soloMercaderia}
                    onChange={() => setSoloMercaderia(!soloMercaderia)}
                    name="solo_mercaderia"
                  />
                }
                style={{ color: 'black', marginLeft: '24px' }}
                />
              ) : undefined}
            </CardHeader>
            {!importDataOperation ? (
              <>
                <CardHeader icon>
                  <span className={classes.cardIconTitle} style={{marginBottom: '-30px'}}>
                    <h4></h4>
                    <AllowedGuard permission={ConstantPermissions.PURCH_PURCHASES_STORE}>
                      <Tooltip title="Recalcular" placement="bottom" style={{marginTop: '-50px'}}>
                        <Button
                          color={props.themeContext.buttonColor}
                          size="sm"
                          justIcon
                          round
                          onClick={refreshPurchase}
                          disabled={stateValidation}
                        >
                          <Sync />
                        </Button>
                      </Tooltip>
                    </AllowedGuard>
                  </span>
                </CardHeader>
                <CardBody>
                  {Object.keys(purchase).length > 0 || id == 0 ? (
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        //saveHeader(purchase);
                        ruta();
                      }}
                      ref={form}
                    >
                      <GridContainer>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Proveedor"
                            value={purchase.CardName || ''}
                            margin="normal"
                            inputProps={{ readOnly: true }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment
                                  style={{ cursor: 'pointer', color: '#07c107' }}
                                  onClick={() => {
                                    setOpen(true);
                                  }}
                                  position="start"
                                  disablePointerEvents={stateValidation}
                                >
                                  <Search />
                                </InputAdornment>
                              ),
                            }}
                            fullWidth
                          />
                        </GridItem>
                        {warehouses.length > 0 && queryType == 'M' ? (
                          <GridItem xs={12} lg={2} xl={2}>
                            <FormControl fullWidth margin="normal" required={id == 0}>
                              <InputLabel>Almacén</InputLabel>
                              <Select
                                MenuProps={{
                                  className: classes.selectMenu,
                                }}
                                defaultValue={purchase.logi_warehouse_id || ''}
                                inputProps={{ name: 'logi_warehouse_id' }}
                                disabled={stateValidation}
                              >
                                {warehouses.map((item, i) => {
                                  return (
                                    <MenuItem value={item.id} key={i}>
                                      {item.WhsName}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </GridItem>
                        ) : undefined}
                        {queryType == 'P' ? (
                          <GridItem xs={12} lg={2} xl={2}>
                            <FormControl fullWidth margin="normal" required={id == 0}>
                              <InputLabel>Tipo de compra</InputLabel>
                              <Select
                                MenuProps={{
                                  className: classes.selectMenu,
                                }}
                                defaultValue={purchase.purchase_type || '01'}
                                inputProps={{ name: 'purchase_type' }}
                                disabled={stateValidation}
                              >
                                {purchaseTypes.map((item, i) => {
                                  return (
                                    <MenuItem value={item.code} key={i}>
                                      {item.description}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </GridItem>
                        ) : undefined}
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Fec. Documento"
                            type="date"
                            name="tax_date"
                            margin="normal"
                            defaultValue={
                              moment(purchase.tax_date).format('YYYY-MM-DD') ||
                              moment().format('YYYY-MM-DD')
                            }
                            onChange={(e) => setMinDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            // inputProps={{
                            //   min: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
                            // }}
                            required={id == 0}
                            disabled={stateValidation}
                            fullWidth
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Fec. Recepción"
                            type="date"
                            name="reception_date"
                            margin="normal"
                            defaultValue={
                              moment(purchase.reception_date).format('YYYY-MM-DD') ||
                              moment().format('YYYY-MM-DD')
                            }
                            InputLabelProps={{ shrink: true }}
                            required={id == 0}
                            /* disabled={stateValidation ? stateValidation : queryType == 'M'} */
                            disabled
                            fullWidth
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            key={minDate}
                            label="Fec. Vencimiento"
                            type="date"
                            name="DocDueDate"
                            margin="normal"
                            defaultValue={
                              moment(purchase.DocDueDate).format('YYYY-MM-DD') ||
                              moment().format('YYYY-MM-DD')
                            }
                            inputProps={{
                              min: minDate || moment(purchase.tax_date).format('YYYY-MM-DD'),
                            }}
                            InputLabelProps={{ shrink: true }}
                            required={id == 0}
                            disabled={stateValidation}
                            fullWidth
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            key={minDate}
                            label="Fec. Contable"
                            type="date"
                            name="DocDate"
                            margin="normal"
                            defaultValue={
                              moment(purchase.DocDate).format('YYYY-MM-DD') ||
                              moment().format('YYYY-MM-DD')
                            }
                            //no puede ser anterior a la fecha del documento, el mismo dia si
                            inputProps={{
                              min: minDate || moment(purchase.tax_date).format('YYYY-MM-DD'),
                            }}
                            InputLabelProps={{ shrink: true }}
                            required={id == 0}
                            disabled={stateValidation}
                            fullWidth
                          />
                        </GridItem>
                        {queryType === 'P' ? (
                          <GridItem xs={12} lg={2} xl={2}>
                            <FormControl fullWidth margin="normal" required={id == 0}>
                              <InputLabel>Zonas</InputLabel>
                              <Select
                                MenuProps={{
                                  className: classes.selectMenu,
                                }}
                                defaultValue={purchase.base_zone_id || ''}
                                inputProps={{
                                  name: 'base_zone_id',
                                }}
                                disabled={stateValidation}
                              >
                                {zones.map((item, i) => {
                                  return (
                                    <MenuItem value={item.id} key={i}>
                                      {item.description}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </GridItem>
                        ) : undefined}
                        <GridItem xs={12} lg={queryType === 'P' ? 2 : 4} xl={queryType === 'P' ? 2 : 4}>
                          <TextField
                            label="Dirección"
                            name="Address"
                            margin="normal"
                            fullWidth
                            value={purchase.Address || ''}
                            onInput={(e) => {
                              let Address = e.target.value;
                              setPurchase((purchase) => ({ ...purchase, Address }));
                            }}
                            inputProps={{
                              maxLength: 100,
                            }}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <FormControl fullWidth margin="normal" required={id == 0}>
                            <InputLabel>Tipo documento Sunat</InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              defaultValue={purchase.base_sunat_document_type_id || 2}
                              inputProps={{
                                name: 'base_sunat_document_type_id',
                              }}
                              disabled={stateValidation}
                            >
                              {sunatDocumentTypes.map((item, i) => {
                                return (
                                  <MenuItem value={item.id} key={i}>
                                    {item.description}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Serie sunat"
                            name="ReceiptSerie"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.ReceiptSerie || ''}
                            required={id == 0}
                            disabled={stateValidation}
                            inputProps={{ maxLength: 4 /* pattern: '^[A-Z]{1}[A-Z0-9]{1}[0-9]{2}$' */ }}
                            /* InputProps={{
                              endAdornment: (
                                <Adornment
                                  title="Use el sig. formato: F000 - FF00"
                                  type="help"
                                  placement="top"
                                />
                              )
                            }} */
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Número sunat"
                            name="ReceiptNumber"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.ReceiptNumber || ''}
                            required={id == 0}
                            disabled={stateValidation}
                            inputProps={{ maxLength: 9 }}
                            InputProps={{
                              endAdornment: (
                                <Adornment
                                  title="Max. 9 dígitos, Ej: 000001234"
                                  type="help"
                                  placement="top"
                                />
                              ),
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <FormControl fullWidth margin="normal" required={id == 0}>
                            <InputLabel>Término pago</InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              defaultValue={purchase.base_payment_term_id || 1}
                              inputProps={{
                                name: 'base_payment_term_id',
                              }}
                              disabled={stateValidation}
                            >
                              {paymentTs.map((item, i) => {
                                return (
                                  <MenuItem value={item.id} key={i}>
                                    {item.PymntGroup}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Total Doc."
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="DocTotal"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.DocTotal || '0'}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Operación gravada"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="op_gravada"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.op_gravada || '0'}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Operación exonerada"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="op_exonerada"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.op_exonerada || '0'}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Operación inafecta"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="op_inafecta"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.op_inafecta || '0'}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Total trans. gratuita"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="sum_free_transfer"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.sum_free_transfer || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Suma IGV"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="sum_igv"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.sum_igv || 0}
                            required={id == 0}
                            disabled={id != 0}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Monto IGV"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="VatSum"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.VatSum || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Descuento"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="total_discount"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.total_discount || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Descuento monto"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="DiscSum"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.DiscSum || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="% Descuento"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="DiscPrcnt"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.DiscPrcnt || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <FormControl fullWidth margin="normal" required={id == 0}>
                            <InputLabel>Cancelado</InputLabel>
                            <Select
                              defaultValue={purchase.cancelled || 'N'}
                              inputProps={{
                                name: 'cancelled',
                              }}
                              disabled={stateValidation}
                            >
                              <MenuItem value="Y">Si</MenuItem>
                              <MenuItem value="N">No</MenuItem>
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <FormControl fullWidth margin="normal" required={id == 0}>
                            <InputLabel>Tipo moneda</InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              defaultValue={purchase.Currency || 'PEN'}
                              inputProps={{
                                name: 'Currency',
                              }}
                              disabled={stateValidation}
                            >
                              {currencys.map((item, i) => {
                                return (
                                  <MenuItem value={item.DocCurrCod} key={i}>
                                    {item.CurrName}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Impuesto. selec. al consumo"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="SumIsc"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.SumIsc || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Otros tributos"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="SumOtTrib"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.SumOtTrib || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Otros cargos"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="SumOtCarg"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.SumOtCarg || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Total de impuestos"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="VatSumTotal"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.VatSumTotal || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Suma bonificaciones"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="sum_bonification"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.sum_bonification || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Otros tributos"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="SumOtTrib"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.SumOtTrib || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            label="Días crédito"
                            type="number"
                            inputProps={{ min: 0, step: 0.0001 }}
                            name="ExtraDays"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.ExtraDays || 0}
                            required={id == 0}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        <GridItem xs={12} lg={2} xl={2}>
                          <FormControl fullWidth margin="normal" required={id == 0}>
                            <InputLabel>Estado Doc.</InputLabel>
                            <Select
                              defaultValue={purchase.doc_status || 'O'}
                              inputProps={{
                                name: 'doc_status',
                              }}
                              disabled={stateValidation}
                            >
                              <MenuItem value="O">Abierto</MenuItem>
                              <MenuItem value="C">Cerrado</MenuItem>
                            </Select>
                          </FormControl>
                        </GridItem>
                        {queryType == 'M' ? (
                          <GridItem xs={12} lg={2} xl={2}>
                            <TextField
                              label="Vendedor"
                              name="seller_name"
                              margin="normal"
                              inputProps={{ maxLength: 100 }}
                              fullWidth
                              defaultValue={purchase.seller_name || ''}
                              disabled={stateValidation}
                            />
                          </GridItem>
                        ) : undefined}
                        <GridItem xs={12} lg={2} xl={2}>
                          <TextField
                            multiline
                            label="Observación"
                            type="text"
                            inputProps={{ minRows: 1 }}
                            name="observation"
                            margin="normal"
                            fullWidth
                            defaultValue={purchase.observation || ''}
                            disabled={stateValidation}
                          />
                        </GridItem>
                        {Array.isArray(purchRetention) && purchRetention.length > 0 && (
                            <GridItem xs={12} lg={2} xl={2}>
                              <TextField
                                multiline
                                label="Retención"
                                type="number"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="wtliable_retention"
                                margin="normal"
                                fullWidth
                                value={purchRetention?.[0]?.wtliable_retention || ''}
                                // disabled={stateValidation}
                              />
                            </GridItem>
                        )}
                        {purchase.proc_status !== 'D' && purchase.id ? (
                          <GridItem xs={12} lg={2} xl={2}>
                            {!(purchase.proc_status === 'X' && purchase.purch_order_id == null) && checkPurchOrder ? (
                                <FormControl fullWidth margin="normal" required={id == 0}>
                                  <InputLabel>Orden de compra</InputLabel>
                                  <Select
                                    MenuProps={{
                                      className: classes.selectMenu,
                                    }}
                                    defaultValue={purchase.purch_order_id || ''}
                                    inputProps={{ name: 'purch_order_id' }}
                                    disabled={disabledComponent}
                                  >
                                    {purchOrder.map((item, i) => {
                                      return (
                                        <MenuItem value={item.id} key={i}>
                                          {item.id} - {item.CardName} - {item.WhsName}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                            ) : undefined}
                            {purchase.proc_status == 'V' ? (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={checkPurchOrder}
                                    onChange={(e) => setCheckPurchOrder(e.target.checked)}
                                  />
                                }
                                label="Selección de orden de compra"
                                classes={{ label: classes.titleCheckBox }}
                              />
                            ) : undefined}
                          </GridItem>
                        ) : undefined}
                        <GridItem xs={12} lg={2} xl={2} style={{ display: 'flex' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkGuide}
                                onChange={() => setCheckGuide(!checkGuide)}
                                value={checkGuide ? 'Y' : 'N'}
                                icon={<AssignmentTurnedInOutlined />}
                                checkedIcon={<AssignmentTurnedIn />}
                                name="is_guide"
                              />
                            }
                            label="Guardar como guía"
                            style={{ color: 'black' }}
                            className={classes.check}
                          />
                        </GridItem>
                        {purchase.prorate ? (
                          <GridItem
                            xs={12}
                            lg={2}
                            xl={2}
                            style={{ display: 'flex', alignItems: 'flex-end' }}
                          >
                            <h5>Monto Anterior</h5>
                            <b>{purchase.prorate}</b>
                          </GridItem>
                        ) : undefined}
                        <GridItem
                          xs={12}
                          sm={12}
                          xl={12}
                          style={{
                            display: 'flex',
                            justifyContent: isId ? 'space-between' : 'end',
                            alignItems: 'center',
                          }}
                        >
                          {isId ? (
                            <div>
                              <Button
                                type="button"
                                color={props.themeContext.buttonColorDanger}
                                onClick={(e) => {
                                  e.currentTarget.querySelector('input').click();
                                }}
                                size="sm"
                                style={{ marginRight: '15px' }}
                              >
                                <Backup /> PDF
                                <input
                                  ref={inputPdf}
                                  type="file"
                                  accept="application/pdf"
                                  style={{ display: 'none' }}
                                  onChange={(e) => {
                                    const file = e.currentTarget.files[0];
                                    if (file) {
                                      setNamePdf(file.name.split('.').slice(0, -1).join('.'));
                                      uploadFile('pdf', file);
                                    }
                                  }}
                                />
                              </Button>
                              <Button
                                color="info"
                                onClick={(e) => {
                                  e.currentTarget.querySelector('input').click();
                                }}
                                size="sm"
                              >
                                <Backup /> XML
                                <input
                                  ref={inputXml}
                                  type="file"
                                  accept="application/xml"
                                  style={{ display: 'none' }}
                                  onChange={(e) => {
                                    const file = e.currentTarget.files[0];
                                    if (file) {
                                      setNameXml(file.name.split('.').slice(0, -1).join('.'));
                                      uploadFile('xml', file);
                                    }
                                  }}
                                />
                              </Button>
                              <div>
                                <b>PDF: </b> {namePdf}
                              </div>
                              <div>
                                <b>XML: </b> {nameXml}
                              </div>
                            </div>
                          ) : undefined}
                          {purchase.proc_status !== 'V' ? (
                            <Button
                              color={props.themeContext.buttonColorSuccess}
                              className={classes.marginRight}
                              type="submit"
                              disabled={stateValidation}
                            >
                              Guardar
                            </Button>
                          ) : purchase.proc_status == 'V' ? (
                            <Button
                              color={props.themeContext.buttonColorSuccess}
                              className={classes.marginRight}
                              type="submit"
                              disabled={disabledComponent}
                            >
                              Guardar orden de compra
                            </Button>
                          ): undefined}
                          {queryType === 'P' && Object.keys(purchase).length === 0 && (
                            <Button
                              color={props.themeContext.buttonColorSuccess}
                              className={classes.marginRight}
                              disabled={processing}
                              onClick={() => {inputFileRefOpe.current.click()}}
                            >
                              Importar Excel
                            </Button>
                          )}
                        </GridItem>
                      </GridContainer>
                    </form>
                  ) : undefined}
                </CardBody>
              </>
            ) :
              <CardBody>
                <CardContainer
                  icon={null}
                  title="Documentos importados desde Excel:"
                  style={{ height: '600px' }}
                >
                  <DataGrid
                    rows={importDataOperation || []}
                    columns={columns}
                    rowHeight={35}
                    selectionModel={selectionModel}
                    onSelectionModelChange={setSelectionModel}
                    checkboxSelection
                    disableColumnFilter
                    disableColumnMenu
                    disableColumnReorder
                    localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                  />
                </CardContainer>
                <GridContainer>
                  <GridItem xs={12} xl={2}>
                    <Button
                      fullWidth
                      color="success"
                      onClick={() => saveFacturas()}
                      disabled={processing}
                    >
                      Procesar
                    </Button>
                  </GridItem>
                  <GridItem xs={12} xl={2}>
                    <Button
                      fullWidth
                      color="info"
                      onClick={() => emptyImport()}
                      disabled={processing}
                    >
                      Limpiar importación
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            }
          </Card>
        </GridItem>
        {isId ? (
          <InvoiceSubDetail
            id={id}
            queryType={queryType}
            taxes={taxes}
            purchase={purchase}
            purchaseDetails={purchaseDetails}
            listPurchaseDetails={listPurchaseDetails}
            getPurchase={getPurchase}
            getValuesInput={getValuesInput}
            unitValue={unitValue}
            setUnitValue={setUnitValue}
            showNotify={showNotify}
            classes={classes}
            stateValidation={stateValidation}
            prorate={alertProrate}
            checkPurchOrder={checkPurchOrder}
            reload={getPurchase}
            pOrderDetalle={pOrderDetalle}
            purchRetention={purchRetention}
            setPurchRetention={setPurchRetention}
            purchRetentionDocument={purchRetentionDocument}
            setPurchRetentionDocument={setPurchRetentionDocument}
          />
        ) : undefined}
      </GridContainer>
    </>
  );
});
